(ns practitest.frontend.integration-settings.entity-mapping.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::entity-mapping
 (fn [db _]
   (:entity-mapping db)))

(re-frame/reg-sub
 ::loading?
 :<- [::entity-mapping]
 (fn [m _]
   (:loading? m)))

(re-frame/reg-sub
 ::data
 :<- [::entity-mapping]
 (fn [m _]
   (:data m)))

(re-frame/reg-sub
 ::integration-name
 :<- [::entity-mapping]
 (fn [m _]
   (:integration-name m)))

(re-frame/reg-sub
 ::bugtracker
 :<- [::entity-mapping]
 (fn [m _]
   (:bugtracker m)))

(re-frame/reg-sub
 ::issues-sync-enabled?
 :<- [::data]
 (fn [data _]
   (:issues_sync_enabled data true)))

(re-frame/reg-sub
 ::requirements-sync-enabled?
 :<- [::data]
 (fn [data _]
   (:requirements_sync_enabled data true)))

(re-frame/reg-sub
 ::sync-all-lists?
 :<- [::data]
 (fn [data _]
   (:sync_all_lists data false)))

(re-frame/reg-sub
 ::selected-project-ids
 :<- [::entity-mapping]
 (fn [m _]
   (:selected-project-ids m #{})))

(re-frame/reg-sub
 ::available-projects
 :<- [::entity-mapping]
 (fn [m _]
   (:available-projects m [])))

(re-frame/reg-sub
 ::projects-loading?
 :<- [::entity-mapping]
 (fn [m _]
   (:projects-loading? m false)))

(re-frame/reg-sub
 ::configured-lists
 :<- [::entity-mapping]
 (fn [m _]
   (:configured-lists m [])))

(re-frame/reg-sub
 ::configured-projects
 :<- [::entity-mapping]
 (fn [m _]
   (:configured-projects m [])))

(re-frame/reg-sub
 ::project-work-item-types
 :<- [::entity-mapping]
 (fn [m _]
   (:project-work-item-types m {})))

(re-frame/reg-sub
 ::project-types-loading-set
 :<- [::entity-mapping]
 (fn [m _]
   (:project-types-loading m #{})))

(re-frame/reg-sub
 ::project-types-loading?
 :<- [::project-types-loading-set]
 (fn [loading-set [_ id]]
   (contains? loading-set id)))

(re-frame/reg-sub
 ::available-spaces
 :<- [::entity-mapping]
 (fn [m _]
   (:available-spaces m [])))

(re-frame/reg-sub
 ::spaces-loading?
 :<- [::entity-mapping]
 (fn [m _]
   (:spaces-loading? m false)))

(re-frame/reg-sub
 ::selected-space-ids
 :<- [::entity-mapping]
 (fn [m _]
   (:selected-space-ids m #{})))

(re-frame/reg-sub
 ::available-lists-by-space
 :<- [::entity-mapping]
 (fn [m _]
   (:available-lists-by-space m {})))

(re-frame/reg-sub
 ::lists-loading?
 :<- [::entity-mapping]
 (fn [m _]
   (seq (:lists-loading m #{}))))

(re-frame/reg-sub
 ::saving?
 :<- [::entity-mapping]
 (fn [m _]
   (:saving? m false)))

(re-frame/reg-sub
 ::dirty?
 :<- [::entity-mapping]
 (fn [m _]
   (let [data       (:data m)
         saved-data (:saved-data m)]
     (and (some? saved-data)
          (not= data saved-data)))))
